module.exports = __webpack_public_path__ + "img/Success.44fb798c.svg";